import React from 'react';
import { Button, message } from 'antd';
import { CrossIcon, SuccessIcon } from '@icons';

type TranscriptionReadyPayload = {
  assetId?: string;
  assetVersionId?: string;
  assetName?: string;
};

type ShowTranscriptionReadyToastParams = {
  payload: TranscriptionReadyPayload;
  onViewTranscript: () => void;
  showViewButton?: boolean;
};

export function showTranscriptionReadyToast({
  payload,
  onViewTranscript,
  showViewButton = true
}: ShowTranscriptionReadyToastParams) {
  const messageKey = `transcription-ready-${
    payload?.assetVersionId || payload?.assetId
  }`;
  const canViewTranscript =
    showViewButton && !!payload?.assetId && !!payload?.assetVersionId;

  message.success({
    key: messageKey,
    content: (
      <div className="message-dark-modal-content">
        <div className="message-dark-modal-inner">
          Transcript ready for &quot;{payload?.assetName}&quot;
        </div>
        {canViewTranscript && (
          <Button
            onClick={() => {
              message.destroy(messageKey);
              onViewTranscript();
            }}
            type="primary"
          >
            View transcript
          </Button>
        )}
        <CrossIcon
          onClick={() => message.destroy(messageKey)}
          className="message-dark-modal-close-btn"
        />
      </div>
    ),
    className: 'message-dark-modal transcription-ready-modal',
    icon: <SuccessIcon className="anticon" />
  });
}
